import { useContext, useEffect, useState, useRef } from "react";
import api from "../api/axios";

import { NavLink } from "react-router-dom";

import {
  Divider,
  Grid,
  Typography,
  Button,
  Chip,
  Box,
  Fade,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import {
  Markunread,
  BusinessCenter as BusinessCenterIcon,
  ExpandMore as ExpandMoreIcon,
  AccessTime,
  Gavel,
  Warning,
  Call,
} from "@mui/icons-material";

import "./Scss/PanelStyles.scss?v=1.1.5";
import { UserContext } from "../Components/Context/Context";
import {
  dateFormat,
  formatToTenDigits,
  quitarTildes,
} from "../Components/helpers/Helpers";
import dayjs from "dayjs";
import { CustomIconsPlusText } from "../Components/Common/Design/CustomIconsPlusText";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import AnimatedCounter from "../Components/AnimatedCounter";

const PAGE_SIZE = 20;

const Panel = () => {
  const { userData } = useContext(UserContext);
  const { user, isSuperAdmin } = userData;
  const initialLazyState = { data: [], total: 0 };

  const [pendingAnotherCases, setPendingAnotherCases] =
    useState(initialLazyState);
  const [pendingCases, setPendingCases] = useState(initialLazyState);
  const [newContacts, setNewContacts] = useState(initialLazyState);
  const [alerts, setAlerts] = useState(initialLazyState);

  const [allUserCases, setAllUserCases] = useState([]);
  const [allUserCasesMessages, setAllUserCasesMessages] = useState([]);
  const [loadingSections, setLoadingSections] = useState({
    contacts: true,
    alerts: true,
    pendingCases: true,
    anotherCases: true,
    caseMessages: true,
    allCases: true,
  });

  // Lazy load refs
  const contactsRef = useRef();
  const alertsRef = useRef();
  const pendingRef = useRef();
  const anotherRef = useRef();

  const [contactsVisible, setContactsVisible] = useState(PAGE_SIZE);
  const [alertsVisible, setAlertsVisible] = useState(PAGE_SIZE);
  const [pendingVisible, setPendingVisible] = useState(PAGE_SIZE);
  const [anotherVisible, setAnotherVisible] = useState(PAGE_SIZE);

  const isPanelReady = Object.values(loadingSections).every((v) => !v);

  useEffect(() => {
    if (!user?.id) return;

    const initPanel = async () => {
      // setFlag(false);

      try {
        // Cargar las secciones iniciales en paralelo reduce la espera total.
        const sections = [
          "contacts",
          "alerts",
          "pendingCases",
          "anotherCases",
          "caseMessages",
          "allCases",
        ];

        await Promise.all(
          sections.map((section) => fetchSection(section, 0, PAGE_SIZE)),
        );
      } catch (error) {
        console.error("Error cargando panel:", error);

        setAllUserCases([]);
        setAllUserCasesMessages([]);
        setNewContacts([]);
        setAlerts([]);
        setPendingCases([]);
        setPendingAnotherCases([]);
      }
      //  finally {
      //   setFlag(true);
      // }
    };

    initPanel();
  }, [user]);

  /* ===========================
     Funciones comunes
  ============================ */

  const setSectionLoading = (section, value) => {
    setLoadingSections((prev) => ({
      ...prev,
      [section]: value,
    }));
  };

  /* ===========================
   Lazy Load Functions
=========================== */
  const fetchSection = async (section, offset = 0, limit = PAGE_SIZE) => {
    if (!user?.id) return;

    if (offset === 0) setSectionLoading(section, true);

    console.log(user.id, section, offset, limit);

    try {
      const { data } = await api.post("/infolazy", {
        user_id: user.id,
        section,
        offset,
        limit,
        company_id: isSuperAdmin ? null : user?.company_id,
      });

      console.log(data);

      if (!data.success) return;

      switch (section) {
        case "contacts":
          // console.log(data.data);

          // const filteredContacts = (data.data || []).filter((c) => c.lawyer);
          // console.log(filteredContacts);

          offset === 0
            ? setNewContacts({
                data: data.data || [],
                total: data.total || 0,
              })
            : setNewContacts((prev) => ({
                ...prev,
                data: [...(prev.data || []), ...(data.data || [])],
              }));
          break;

        case "alerts":
          offset === 0
            ? setAlerts({
                data: data.data || [],
                total: data.total || 0,
              })
            : setAlerts((prev) => ({
                ...prev,
                data: [...(prev.data || []), ...(data.data || [])],
              }));
          break;

        case "pendingCases":
          offset === 0
            ? setPendingCases({
                data: data.data || [],
                total: data.total || 0,
              })
            : setPendingCases((prev) => ({
                ...prev,
                data: [...(prev.data || []), ...(data.data || [])],
              }));
          break;

        // case "pendingCases":
        //   offset === 0
        //     ? setPendingCases(data || [])
        //     : setPendingCases((prev) => [...prev, ...(data || [])]);
        //   break;
        case "anotherCases":
          offset === 0
            ? setPendingAnotherCases({
                data: data.data || [],
                total: data.total || 0,
              })
            : setPendingAnotherCases((prev) => ({
                ...prev,
                data: [...(prev.data || []), ...(data.data || [])],
              }));
          break;

        case "caseMessages":
          offset === 0
            ? setAllUserCasesMessages(data?.data || [])
            : setAllUserCasesMessages((prev) => [
                ...prev,
                ...(data?.data || []),
              ]);
          break;

        case "allCases":
          offset === 0
            ? setAllUserCases(data?.data || [])
            : setAllUserCases((prev) => [...prev, ...(data?.data || [])]);
          break;

        default:
          break;
      }
    } catch (err) {
      console.error(`Error cargando ${section}:`, err);
    } finally {
      if (offset === 0) setSectionLoading(section, false);
    }
  };

  const RenderVencimiento = ({
    last_task: current_task,
    cases_flow_relation: flow,
    flagFromPanel = false,
  }) => {
    if (!current_task?.date_end) return null;

    const fechaFormateada = dateFormat(current_task.date_end);
    const iconSize = { width: "15px", height: "15px" };
    const diffDays = dayjs(current_task.date_end).diff(dayjs(), "day");
    const isJuicio = quitarTildes(flow?.status_name) === "juicio";
    const isActive = current_task?.status === 0;

    const renderEstado = () => {
      if (!isActive) return null;
      if (isJuicio) {
        if (diffDays > 15)
          return (
            <CustomIconsPlusText
              icon={Gavel}
              iconStyles={iconSize}
              text="FECHA DE JUICIO"
              blink="blinking"
              severity="warning"
              variant="contained"
            />
          );
        if (diffDays > 0 && diffDays <= 15)
          return (
            <CustomIconsPlusText
              icon={Gavel}
              iconStyles={iconSize}
              text={`JUICIO EN ${diffDays} DÍAS`}
              blink="blinking"
              severity="error"
              variant="contained"
            />
          );
      }
      if (diffDays > 5)
        return (
          <CustomIconsPlusText
            icon={AccessTime}
            iconStyles={iconSize}
            severity="info"
            text={`${diffDays} días para finalizar la tarea`}
            variant="outlined"
          />
        );
      if (diffDays > 0 && diffDays <= 5)
        return (
          <CustomIconsPlusText
            icon={Warning}
            iconStyles={iconSize}
            blink="blinking"
            severity="warning"
            text={`${diffDays} días para finalizar la tarea`}
            variant="outlined"
          />
        );
      return (
        <CustomIconsPlusText
          icon={Warning}
          iconStyles={iconSize}
          blink="blinking"
          severity="error"
          text={`Tarea vencida hace ${Math.abs(diffDays)} días`}
          variant="outlined"
        />
      );
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: flagFromPanel ? "row" : "column",
          gap: "3px",
          padding: "2px",
        }}
      >
        {renderEstado()}
        <CustomIconsPlusText
          icon={AccessTime}
          iconStyles={iconSize}
          severity="none"
          text={`Fecha: ${fechaFormateada}`}
          variant="outlined"
        />
      </div>
    );
  };

  /* ===========================
     Lazy load scroll
  ============================ */
  const handleScrollLazy = (ref, visible, total, fetchFn, loading) => {
    if (!ref.current || loading) return;

    const el = ref.current;

    if (
      el.scrollTop + el.clientHeight >= el.scrollHeight - 10 &&
      visible < total
    ) {
      fetchFn();
    }
  };

  /* ===========================
     Renderers por sección
  ============================ */

  const renderNewContacts = () => {
    // console.log("ENTRA", newContacts);

    if (loadingSections?.contacts) {
      return <LoadingPage isLoading heightProp={"30vh"} />;
    }

    if (!newContacts?.data?.length)
      return (
        <Typography variant="body2" color="text.secondary">
          No tienes contactos nuevos pendientes.
        </Typography>
      );

    return (
      <Fade in timeout={800}>
        <Box
          ref={contactsRef}
          onScroll={() =>
            handleScrollLazy(
              contactsRef,
              contactsVisible,
              newContacts.total,
              () => {
                fetchSection("contacts", contactsVisible, PAGE_SIZE);
                setContactsVisible((prev) => prev + PAGE_SIZE);
              },
              loadingSections.contacts,
            )
          }
          sx={{
            maxHeight: "380px", // máximo permitido
            minHeight: "50px", // ajustable al contenido
            overflow: "auto",
          }}
        >
          {newContacts?.data?.slice(0, contactsVisible).map((c, idx) => {
            const daysAgo = c.date_in
              ? dayjs().diff(dayjs(c.date_in), "day")
              : null;
            let chipColor = "#23c6c8";
            if (daysAgo !== null) {
              if (daysAgo > 10) chipColor = "#e74c3c";
              else if (daysAgo > 5) chipColor = "#f39c12";
            }
            return (
              <Box
                key={idx}
                sx={{
                  p: 1,
                  borderBottom: "1px solid #eee",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography fontWeight={600}>
                  {c.name} {c.surname}
                </Typography>
                <Box>
                  <Chip
                    label={
                      daysAgo !== null
                        ? `Creado hace ${daysAgo} día${daysAgo !== 1 ? "s" : ""}`
                        : "Fecha no disponible"
                    }
                    size="small"
                    sx={{ backgroundColor: chipColor, color: "white", mr: 2 }}
                  />
                  <Chip
                    label={"Pendiente de llamada"}
                    icon={<Call sx={{ fontSize: 16, color: "white" }} />}
                    size="small"
                    color="warning"
                    sx={{ mr: 2 }}
                  />
                  <Button
                    color="info"
                    variant="outlined"
                    size="small"
                    component={NavLink}
                    target="_blank"
                    to={`/contactos/ver?id=${c.id}`}
                  >
                    Ir a contacto
                  </Button>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Fade>
    );
  };

  const renderAlerts = () => {
    if (loadingSections?.alerts) {
      return <LoadingPage isLoading heightProp={"30vh"} />;
    }

    if (!alerts?.data?.length)
      return (
        <Typography variant="body2" color="text.secondary">
          No tienes alertas activas.
        </Typography>
      );

    return (
      <Fade in timeout={800}>
        <Box
          ref={alertsRef}
          onScroll={() =>
            handleScrollLazy(
              alertsRef,
              alertsVisible,
              alerts.total,
              () => {
                fetchSection("alerts", alertsVisible, PAGE_SIZE);
                setAlertsVisible((prev) => prev + PAGE_SIZE);
              },
              loadingSections.alerts,
            )
          }
          sx={{
            maxHeight: "380px", // límite máximo del scroll
            minHeight: "50px", // se ajusta al contenido mínimo
            overflow: "auto",
          }}
        >
          {alerts?.data
            ?.slice(0, alertsVisible)
            .map(({ case_id, date, message }, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: 1,
                  mb: 1,
                  p: 1,
                  borderRadius: "10px",
                  background: "#f9f9f9",
                  border: "1px solid #eee",
                  marginBottom: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Chip label={`#${formatToTenDigits(case_id)}`} size="small" />
                  <Chip
                    label={date}
                    size="small"
                    sx={{ backgroundColor: "#23c6c8", color: "white" }}
                  />
                  <Typography
                    variant="body2"
                    className="myMessage"
                    dangerouslySetInnerHTML={{ __html: message }}
                    sx={{
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      flexBasis: "100%", //
                    }}
                  />
                </Box>
                <Button
                  size="small"
                  component={NavLink}
                  to={`/expedientes/ver?id=${case_id}`}
                  target="_blank"
                  variant="outlined"
                  color="success"
                  sx={{
                    whiteSpace: "nowrap",
                    alignSelf: "flex-start",
                  }}
                >
                  Ir al Expediente
                </Button>
              </Box>
            ))}
        </Box>
      </Fade>
    );
  };

  const renderPendingNotification = () => {
    if (loadingSections?.pendingCases) {
      return <LoadingPage isLoading heightProp={"30vh"} />;
    }

    if (!pendingCases?.data?.length)
      return (
        <Typography variant="body2" color="text.secondary">
          No hay cambios recientes en tus expedientes.
        </Typography>
      );
    const sorted = [...pendingCases?.data].sort((a, b) => {
      const dateA = a?.last_task?.date_end ? dayjs(a.last_task.date_end) : null;
      const dateB = b?.last_task?.date_end ? dayjs(b.last_task.date_end) : null;
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateA.diff(dateB);
    });
    return (
      <Fade in timeout={800}>
        <Box
          ref={pendingRef}
          onScroll={() =>
            handleScrollLazy(
              pendingRef,
              pendingVisible,
              pendingCases.total,
              () => {
                fetchSection("pendingCases", pendingVisible, PAGE_SIZE);
                setPendingVisible((prev) => prev + PAGE_SIZE);
              },
              loadingSections.pendingCases,
            )
          }
          sx={{
            maxHeight: "380px", // límite máximo del scroll
            minHeight: "50px", // se ajusta al contenido mínimo
            overflow: "auto",
          }}
        >
          {sorted.slice(0, pendingVisible).map((item, idx) => (
            <Box
              key={idx}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                p: "3px 10px",
                backgroundColor: "#fafafa",
                display: "flex",
                flexDirection: "column",
                gap: "3px",
                marginBottom: "3px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", gap: "8px" }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Expediente #{formatToTenDigits(item.id)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.full_case_status_name}
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    <RenderVencimiento {...item} flagFromPanel={true} />
                  </Box>
                </Box>

                <Button
                  size="small"
                  component={NavLink}
                  to={`/expedientes/ver?id=${item.id}`}
                  variant="outlined"
                  target="_blank"
                  color="success"
                >
                  Ir al expediente
                </Button>
              </Box>
              {/* <Divider /> */}
            </Box>
          ))}
        </Box>
      </Fade>
    );
  };

  const renderAnotherNotifications = () => {
    if (loadingSections?.anotherCases) {
      return <LoadingPage isLoading heightProp={"30vh"} />;
    }

    if (!pendingAnotherCases?.data?.length)
      return (
        <Typography variant="body2" color="text.secondary">
          No hay cambios recientes en tus expedientes.
        </Typography>
      );
    const sorted = [...pendingAnotherCases?.data].sort((a, b) => {
      const dateA = a?.last_task?.date_end ? dayjs(a.last_task.date_end) : null;
      const dateB = b?.last_task?.date_end ? dayjs(b.last_task.date_end) : null;
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateA.diff(dateB);
    });
    return (
      <Fade in timeout={800}>
        <Box
          ref={anotherRef}
          onScroll={() =>
            handleScrollLazy(
              anotherRef,
              anotherVisible,
              pendingAnotherCases.total,
              () => {
                fetchSection("anotherCases", anotherVisible, PAGE_SIZE);
                setAnotherVisible((prev) => prev + PAGE_SIZE);
              },
              loadingSections.anotherCases,
            )
          }
          sx={{
            maxHeight: "380px",
            minHeight: "50px",
            overflow: "auto",
          }}
        >
          {sorted.slice(0, anotherVisible).map((item, idx) => (
            <Box
              key={idx}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                p: "3px 10px",
                backgroundColor: "#fafafa",
                display: "flex",
                flexDirection: "column",
                gap: "3px",
                marginBottom: "3px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", gap: "8px" }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Expediente #{formatToTenDigits(item.id)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.full_case_status_name}
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    <RenderVencimiento {...item} flagFromPanel={true} />
                  </Box>
                </Box>
                <Button
                  size="small"
                  component={NavLink}
                  to={`/expedientes/ver?id=${item.id}`}
                  target="_blank"
                  variant="outlined"
                  color="success"
                >
                  Ir al expediente
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      </Fade>
    );
  };

  const getStatusStyles = (statusName = "") => {
    const normalized = quitarTildes(statusName.toLowerCase());
    if (normalized.includes("cancelad")) return { borderColor: "#d32f2f" };
    if (normalized.includes("pendiente")) return { borderColor: "#f9a825" };
    return { borderColor: "#1976d2" };
  };

  const summarizedCases = allUserCases.reduce((acc, item) => {
    const taskStatus = item?.last_task?.status;

    // Excluir tareas activas (status 0)
    if (taskStatus === 0) return acc;

    const statusName = item?.full_case_status_name || item?.status_name || "";

    if (!statusName) return acc;

    const excludedStateKeywords = ["pendiente", "finalizado"];
    const normalized = quitarTildes(statusName.toLowerCase());

    if (excludedStateKeywords.some((word) => normalized.includes(word)))
      return acc;

    const caseTypeName = item?.case_type_name || "Sin tipo";

    if (!acc[statusName]) acc[statusName] = {};
    if (!acc[statusName][caseTypeName]) acc[statusName][caseTypeName] = 0;

    acc[statusName][caseTypeName] += 1;

    return acc;
  }, {});

  const renderCasesSummary = () => {
    const statusEntries = Object.entries(summarizedCases);

    // console.log(allUserCases);

    if (!statusEntries.length)
      return (
        <Typography variant="body2" color="text.secondary">
          No tienes expedientes en estados avanzados.
        </Typography>
      );
    return (
      <Grid container spacing={2}>
        {statusEntries.map(([statusName, caseTypes], idx) => {
          const styles = getStatusStyles(statusName);
          return (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  borderLeft: `4px solid ${styles.borderColor}`,
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: "text.secondary",
                  }}
                >
                  Estado
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {statusName}
                </Typography>
                <Divider sx={{ mb: 1 }} />
                {Object.entries(caseTypes).map(([caseTypeName, count], i) => (
                  <Box
                    key={i}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2">{caseTypeName}</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {count}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const infoSections = [
    // !isSuperAdmin &&
    {
      key: "contacts",
      title: "Nuevos contactos",
      count: newContacts.total,
      renderContent: renderNewContacts,
    },
    {
      key: "alerts",
      title: "Tus Alertas",
      count: alerts.total,
      renderContent: renderAlerts,
    },
    {
      key: "pending",
      title: "Tus Notificaciones",
      count: pendingCases.total,
      renderContent: renderPendingNotification,
    },
    {
      key: "another",
      title: "Otras Notificaciones",
      count: pendingAnotherCases.total,
      renderContent: renderAnotherNotifications,
    },
  ].filter(Boolean);

  const panelStats = [
    {
      color: "#23c5c8",
      icon: <Markunread className="panelIcon" />,
      label: "Nuevos emails",
      value: allUserCasesMessages?.length,
      link: "/mensajes",
      sx: { cursor: "pointer" },
    },
    {
      color: "#f8ac59",
      icon: <BusinessCenterIcon className="panelIcon" />,
      label: "Tus expedientes",
      value: allUserCases?.length,
    },
  ];

  // console.log({
  //   contacts: newContacts.length,
  //   alerts: alerts.length,
  //   pending: pendingCases.length,
  //   another: pendingAnotherCases.length,
  // });

  return (
    <>
      {/* {!isPanelReady && <LoadingPage isLoading />} */}

      <Fade in timeout={600}>
        <Grid
          container
          item
          xs={11.8}
          className="panelContainer"
          sx={{
            p: { xs: 2.5, sm: 2.5, md: 4 },
            mt: 1,
            mb: 2,
            mx: "auto",
            borderRadius: 3,
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.98) 100%)",
            border: "1px solid rgba(148, 163, 184, 0.22)",
            boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
            minHeight: "100%",
          }}
        >
          <Grid item xs={12} mb={1.5}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                letterSpacing: "-0.02em",
                color: "#0f172a",
              }}
            >
              Bienvenid@, {user?.name} {user?.surname}
            </Typography>
          </Grid>
          <Grid item xs={12} mb={2}>
            <Typography
              variant="body1"
              sx={{
                color: "#475569",
                fontWeight: 500,
              }}
            >
              Tienes {allUserCasesMessages.length} mensajes sin leer,{" "}
              {pendingCases.total} notificaciones y {alerts.total} alertas
            </Typography>
          </Grid>
          <Divider
            sx={{
              width: "100%",
              mb: 2.5,
              borderColor: "rgba(148, 163, 184, 0.28)",
            }}
          />
          <Grid item xs={12}>
            {infoSections
              .filter(({ count }) => count > 0)
              .map(({ title, count, renderContent }, index) => (
                <Accordion
                  key={index}
                  defaultExpanded={title === "Tus Alertas"}
                  sx={{
                    mb: 1.5,
                    borderRadius: "14px",
                    border: "1px solid rgba(148, 163, 184, 0.2)",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                    "&:before": { display: "none" },
                    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography fontWeight={600}>{title}</Typography>
                      <Chip
                        label={count}
                        size="small"
                        sx={{ backgroundColor: "#1976d2", color: "white" }}
                      />
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>{renderContent()}</AccordionDetails>
                </Accordion>
              ))}
          </Grid>
          {/* Stats panel */}
          <Grid
            container
            justifyContent="center"
            height={130}
            mt={3}
            spacing={1.5}
            sx={{ px: { xs: 0, sm: 0.5 } }}
          >
            {panelStats.map(
              ({ color, icon, label, value, sx, link }, index) => (
                <Grid key={index} item xs={6} p={0.5} sx={{ height: "100%" }}>
                  <Grid
                    component={link ? NavLink : "div"}
                    to={link || undefined}
                    container
                    sx={{
                      ...sx,
                      background: `linear-gradient(135deg, ${color} 0%, #ffffffff 100%)`,
                      borderRadius: 2,
                      border: "1px solid rgba(255,255,255,0.7)",
                      boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
                      height: "100%",
                      color: "white",
                      textDecoration: "none",
                      cursor: link ? "pointer" : "default",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: "0 14px 28px rgba(15, 23, 42, 0.16)",
                      },
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    }}
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 1,
                      }}
                    >
                      {icon}
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      container
                      direction="column"
                      justifyContent="space-between"
                      alignItems="flex-end"
                      p={1}
                    >
                      <Typography sx={{ fontWeight: 600, lineHeight: 1.1 }}>
                        {label}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "72px",
                          lineHeight: 1,
                          // fontWeight: 700,
                          letterSpacing: "3px",
                          background:
                            "linear-gradient(180deg, #ffffff 0%, #f0f0f0 100%)",
                          WebkitBackgroundClip: "text",
                          // WebkitTextFillColor: "transparent",
                          textShadow: "0px 4px 12px rgba(0,0,0,0.25)",
                        }}
                      >
                        <AnimatedCounter value={value} />
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            )}
          </Grid>

          <Grid
            item
            xs={12}
            mt={3}
            sx={{
              p: 2,
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(248,250,252,0.7), rgba(255,255,255,0.9))",
              border: "1px solid rgba(148,163,184,0.18)",
              boxShadow: "0 8px 22px rgba(15, 23, 42, 0.04)",
            }}
          >
            <Typography
              variant="h6"
              className="title"
              sx={{
                fontWeight: 700,
                color: "#0f172a",
                mb: 1.5,
              }}
            >
              Tus Expedientes
            </Typography>
            <Grid item xs={12}>
              {renderCasesSummary()}
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </>
  );
};

export default Panel;
